import(/* webpackMode: "eager" */ "/opt/stpi-client/src/app/(index)/chronicle/page.tsx");
